export default {
  title: '数据展览',
  rechargeRankingDay: '当日充值排行',
  rechargeAmount: '充值数',
  usersNumber: '用户数',
  orderNumber: '订单数',
  gameNumber: '游戏数',
  gameID: '游戏ID',
  effectiveRechargeRatio: '有效充值占比',
  cooperativeCompany: '合作公司',
  fullServerRecharge: '全服充值',
};
